import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CustomOrderConfirmationModule } from './custom-order-confirmation/custom-order-confirmation.module'
import { CustomOrderDetailsModule } from './custom-order-details/custom-order-details.module'
import { CustomOrderHistoryModule } from './custom-order-history/custom-order-history.module'
import { OrderStatusModule } from './order-status/order-status.module'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CustomOrderConfirmationModule,
    CustomOrderDetailsModule,
    CustomOrderHistoryModule,
    OrderStatusModule
  ],
  providers: [],
  exports: []
})
export class CustomOrderModule {}
